export const documentOrder: Record<string, number> = {
  DOCUMENT_DEFICIENCY: 1,
  SERVICE_AGREEMENT: 2,
  TERMS_CONDITIONS: 3,
  APPENDIX: 4,
  CUSTOM_AGREEMENT: 5,
};
